import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "./App.tsx";
import "./index.css";
import { AppProvider } from "./contexts/AppContext";
import { CartProvider } from "./contexts/CartContext";
import { AuthProvider } from "./contexts/AuthContext";
import { CheckoutProvider } from "./contexts/CheckoutContext";
import { NotificationsProvider } from "./contexts/NotificationsContext";
import { OrderHistoryProvider } from "./contexts/OrderHistoryContext";
import { ModalsProvider } from "./contexts/ModalsContext";
import { AnnouncementsProvider } from "./contexts/AnnouncementsContext";
import { StorePricingProvider } from "./contexts/StorePricingContext";
import { initSentry, SentryErrorBoundary } from "./lib/sentry";

// Sentry 초기화 (앱 렌더링 전)
initSentry();

// #670 R2: 배포 번들 판별 핑거프린트 — dev 실측 시 콘솔에서
// `window.__OLULO_BUILD__` 로 현재 번들의 커밋 SHA 를 즉시 확정한다.
// (vitest 등 define 미주입 환경 방어 — typeof 가드)
if (typeof __BUILD_COMMIT__ !== 'undefined') {
  window.__OLULO_BUILD__ = { commit: __BUILD_COMMIT__, builtAt: __BUILD_TIME__ };
}

createRoot(document.getElementById("root")!).render(
  <SentryErrorBoundary fallback={<div className="flex items-center justify-center min-h-screen">오류가 발생했습니다. 페이지를 새로고침해주세요.</div>}>
    <BrowserRouter>
      <AppProvider>
        <StorePricingProvider>
          <AuthProvider>
            <CartProvider>
              <CheckoutProvider>
                <NotificationsProvider>
                  <OrderHistoryProvider>
                    <ModalsProvider>
                      <AnnouncementsProvider>
                        <App />
                      </AnnouncementsProvider>
                    </ModalsProvider>
                  </OrderHistoryProvider>
                </NotificationsProvider>
              </CheckoutProvider>
            </CartProvider>
          </AuthProvider>
        </StorePricingProvider>
      </AppProvider>
    </BrowserRouter>
  </SentryErrorBoundary>
);
